
export const arraysAreIdentical= <T>(arr1: T[], arr2: T[]): boolean => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    let result = arr1.every((value, index) => value === arr2[index]);

    return result;
}


export class arrayUtility {

  /**
   * This method does a group for an array of items by the given property
   * @param items
   * @param key
   * @return It returns an array contains the value of given property as key and NUMBER of occurrence as value.
   * Example: input: ["Id:A","Id:B","Id:B","Id:A","Id:C"] returns ["key:A, value:2","key:B, value:2","key:C, value:1"]
   */

  public static groupBy<T extends Record<string, any>>(items: T[], key: keyof T): { key: T[keyof T]; value: number }[] {
    return items.reduce((groupedItems: { key: T[keyof T]; value: number }[], item: T) => {
      // Find if a group with the same key already exists
      const groupedItem = groupedItems.find((a) => a.key === item[key]);
      if (!groupedItem) {
        // Create a new grouped item if none exists
        groupedItems.push({ key: item[key], value: 1 });
      } else {
        // Increment the value if the group already exists
        groupedItem.value += 1;
      }
      return groupedItems;
    }, []);
  }

  /**
   *
   * @param items Group by method, exactly same as above with simplified implementation
   * @param by
   * @returns
   */
  public static groupBy2(items:any[], by: string) : any[] {
    return items?.filter((project, index, self) => index === self.findIndex(u => project[by] === project[by])).map(p => p[by]);
  }


  /**
   * This method returns the total value of given numeric property in an object array
   * @param items
   * @param key
   */
  public static getTotal(items: any[], key: string){
      return items.reduce((total, item) => {
              total += item[key];
              return total;
              },
              0);
  }

  /**
   * Remove an item from array
   * @param items
   * @param key
   */
  public static remove(items: any[], key: string){
      if(items.indexOf(key) >= 0) {
          return items.splice(items.indexOf(key));
      }
      return items;
  }

  public static groupByMap<TKey, TItem,>(array: TItem[], keySelector: (item: TItem) => TKey): Map<TKey, TItem[]> {
    if (!Array.isArray(array)) {
        throw new TypeError("First argument must be an array.");
    }
    if (typeof keySelector !== "function") {
        throw new TypeError("Key selector must be a function.");
    }

    return array.reduce((map, item) => {
        const key = keySelector(item);
        if (!map.has(key)) {
            map.set(key, []);
        }
        map.get(key).push(item);
        return map;
    }, new Map());
  }
}

